import { UtilityService } from 'src/app/shared/services/utility.service';
import { Api } from 'src/app/shared/constants/api';
import { DataService } from './../../shared/services/data.service';
import { NGXLogger } from 'ngx-logger';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.less'],
    standalone: false
})
export class ResetPasswordComponent implements OnInit {
  hide = true;
  hideConfirm = true;
  resetPassword:FormGroup;
  constructor(private router:Router,private logger: NGXLogger,private formBuilder:FormBuilder,private service: DataService,private activeRoute: ActivatedRoute,private utilityService: UtilityService) { }

  ngOnInit(): void {
    localStorage.clear();
    this.initializeForm();
    this.logger.info('reset- password form data in init method : ',this.resetPassword.value);
    this.processRouteValues();
  }
  /**
   * this method will initialize form
   */
  private initializeForm()  {
    this.resetPassword = this.formBuilder.group({
      verficationCode: [null,[Validators.required]],
      newPassword:[null,[Validators.required]],
      oldPassword:[null,[Validators.required]],
      key:[]
    }, {
      validator: MustMatch('newPassword', 'oldPassword')
  });
    this.logger.info('reset- password form data in initializeForm method : ',this.resetPassword.value);
  }

  private processRouteValues() {
    this.activeRoute.queryParams.subscribe(params => {
      this.logger.info('param ', params);
      this.key = params['key'];
      this.logger.info('key for redirectedUrl ', this.key);
    });
  }

  /**
   * this method will submit the form
   * after submit trigger an email for reset password url
   */
  public onSubmit() {
    this.logger.info('reset- password submit button works data is : ', this.resetPassword.value);
    if(!this.resetPassword.invalid){
      this.service.post(Api.RESET_PASSWORD , this.resetPassword.value).subscribe(res =>{
        this.logger.info('rest password res', res);
        this.utilityService.notifier(res.response,'success');
        this.router.navigate(['/login'])
      });
    }
  }
  /**
   * this method will cancle the form
   */
  public onCancle(){
    this.logger.info('reset- password cancle button works');
    this.router.navigate(['/login'])
  }

  private get key(){ return this.resetPassword.get('key')?.value; }
  private set key(key:string){ this.resetPassword.get('key').setValue(key);}
}
export function MustMatch(controlName: string, matchingControlName: string) {
  return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
          // return if another validator has already found an error on the matchingControl
          return;
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
          matchingControl.setErrors({ mustMatch: true });
      } else {
          matchingControl.setErrors(null);
      }
  }
}
